export default __webpack_public_path__ + "static/media/about.2203f407.png";